/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import UserAction from "../action/UserAction"

export const initialState = ({
    loading: false,
    userList: null,    
    user: null,
})
  
export default function (state = initialState, action) {
    switch (action.type) {
  
      case UserAction.TYPES.REQUEST_USER_LIST:
        return Object.assign({}, state, { userList: null, loading: true})
  
      case UserAction.TYPES.REQUEST_USER_LIST_SUCCESS:
        return Object.assign({}, state, { userList: action.payload, loading: false})

      case UserAction.TYPES.REQUEST_USER_INFO_SUCCESS:
        return Object.assign({}, state, { user: action.payload.data, loading: false})

      case UserAction.TYPES.REQUEST_CREATE_USER_SUCCESS: {
          const newList = state.userList
          newList.data = newList.data.reverse()
          newList.data.push(action.payload.data)
          newList.data = newList.data.reverse()
          return Object.assign({}, state, { userList: newList, loading: false})
      }        
  
      case UserAction.TYPES.REQUEST_UPDATE_USER_SUCCESS: {
        const newList = state.userList
        newList.data = newList.data.map(item => {
          if(item.id == action.payload.data.id) {
            return action.payload.data
          }
          return item
        })
        return Object.assign({}, state, { userList: newList, loading: false})
      }        
  
      default:
        return state
    }
}



  